// Stable codes shared with the API enum; labels belong to the brand namespace.
export const REPORT_TYPES = [
  'violence_threats', 'harassment_abuse', 'hate_discrimination',
  'sexual_child_safety', 'scam_fraud', 'spam_manipulation',
  'privacy_personal_info', 'illegal_regulated_goods', 'self_harm_suicide',
  'intellectual_property', 'defamation_legal',
];
